"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render_api = void 0;
var _lsfastapiClient = require("@lsoft/lsfastapi-client");
var openapi = {
  openapi: "3.1.0",
  info: {
    title: "render-api",
    version: "4.2.0"
  },
  paths: {
    "/render/routes": {
      get: {
        tags: ["render_routes"],
        summary: "Routes Get",
        operationId: "render_routes_get",
        parameters: [{
          name: "org_id",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Org Id"
          }
        }, {
          name: "render_class",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Render Class"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  additionalProperties: {
                    $ref: "#/components/schemas/RenderRouteModel"
                  },
                  title: "Response Routes Get Render Routes Get"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/render/route/{uid}": {
      get: {
        tags: ["render_routes"],
        summary: "Route Get",
        operationId: "render_route__uid__get",
        parameters: [{
          name: "uid",
          "in": "path",
          required: true,
          schema: {
            type: "string",
            title: "Uid"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/RenderRouteModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      "delete": {
        tags: ["render_routes"],
        summary: "Route Delete",
        operationId: "render_route__uid__delete",
        parameters: [{
          name: "uid",
          "in": "path",
          required: true,
          schema: {
            type: "string",
            title: "Uid"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/render/route": {
      post: {
        tags: ["render_routes"],
        summary: "Route Post",
        operationId: "render_route_post",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/RenderRouteBaseModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/RenderRouteModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/render/render_product": {
      post: {
        tags: ["render"],
        summary: "Render Product Post",
        operationId: "render_render_product_post",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/RenderProductRequestModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  anyOf: [{
                    $ref: "#/components/schemas/RenderProductModel"
                  }, {
                    type: "object"
                  }],
                  title: "Response Render Product Post Render Render Product Post"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/render/rendered_product": {
      get: {
        tags: ["render"],
        summary: "Render Product Get",
        operationId: "render_rendered_product_get",
        parameters: [{
          name: "view",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "View"
          }
        }, {
          name: "sku",
          "in": "query",
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          }
        }, {
          name: "render_class",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Render Class"
          }
        }, {
          name: "org_id",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Org Id"
          }
        }, {
          name: "version",
          "in": "query",
          required: true,
          schema: {
            type: "integer",
            title: "Version"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/render/rendered_products": {
      put: {
        tags: ["render"],
        summary: "Render Products Put",
        operationId: "render_rendered_products_put",
        parameters: [{
          name: "render_class",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Render Class"
          }
        }, {
          name: "org_id",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Org Id"
          }
        }, {
          name: "version",
          "in": "query",
          required: true,
          schema: {
            type: "integer",
            title: "Version"
          }
        }, {
          name: "sort",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Sort"
          }
        }, {
          name: "skip",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Skip"
          }
        }, {
          name: "limit",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Limit"
          }
        }, {
          name: "view",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "View"
          }
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                anyOf: [{
                  type: "object"
                }, {
                  type: "null"
                }],
                title: "Body"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/PaginationViewResponseIntIdsModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/render/rendered_products/search": {
      put: {
        tags: ["render"],
        summary: "Render Products Search Put",
        operationId: "render_rendered_products_search_put",
        parameters: [{
          name: "render_class",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Render Class"
          }
        }, {
          name: "org_id",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Org Id"
          }
        }, {
          name: "version",
          "in": "query",
          required: true,
          schema: {
            type: "integer",
            title: "Version"
          }
        }, {
          name: "sort",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Sort"
          }
        }, {
          name: "skip",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Skip"
          }
        }, {
          name: "limit",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Limit"
          }
        }, {
          name: "view",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "View"
          }
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                anyOf: [{
                  type: "object"
                }, {
                  type: "null"
                }],
                title: "Body"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/PaginationViewResponseIntIdsModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/render/rendered_products/meta_data": {
      put: {
        tags: ["render"],
        summary: "Rendered Products Meta Data",
        operationId: "render_rendered_products_meta_data_put",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/RenderedProductMetaDataRequestModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/RenderedProductMetaDataResponseModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/render/rendered_products/gift_finder/1": {
      put: {
        tags: ["render"],
        summary: "Rendered Products Meta Data Gift Finder 1",
        operationId: "render_rendered_products_gift_finder_1_put",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/RenderProductGiftFinderStepBaseModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  items: {
                    type: "string"
                  },
                  type: "array",
                  title: "Response Rendered Products Meta Data Gift Finder 1 Render Rendered Products Gift Finder 1 Put"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/render/rendered_products/gift_finder/2": {
      put: {
        tags: ["render"],
        summary: "Rendered Products Meta Data Gift Finder 2",
        operationId: "render_rendered_products_gift_finder_2_put",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/RenderProductGiftFinderResultStepModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/render/render_classes": {
      get: {
        tags: ["render_class"],
        summary: "Render Classes Get",
        operationId: "render_render_classes_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    },
    "/render/promotion": {
      get: {
        tags: ["render_promotion"],
        summary: "Render All Active Promotions Get",
        operationId: "render_promotion_get",
        parameters: [{
          name: "render_class",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Render Class"
          }
        }, {
          name: "org_id",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Org Id"
          }
        }, {
          name: "version",
          "in": "query",
          required: true,
          schema: {
            type: "integer",
            title: "Version"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/render/promotion/products": {
      get: {
        tags: ["render_promotion"],
        summary: "Render All Promotion Products Get",
        operationId: "render_promotion_products_get",
        parameters: [{
          name: "render_class",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Render Class"
          }
        }, {
          name: "org_id",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Org Id"
          }
        }, {
          name: "version",
          "in": "query",
          required: true,
          schema: {
            type: "integer",
            title: "Version"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/export/minipos": {
      get: {
        tags: ["export"],
        summary: "Export Minipos Get",
        operationId: "export_minipos_get",
        parameters: [{
          name: "org_id",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Org Id"
          }
        }, {
          name: "version",
          "in": "query",
          required: true,
          schema: {
            type: "integer",
            title: "Version"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ExportMiniPosModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/healthz": {
      get: {
        summary: "Healthz Get",
        operationId: "healthz_get_healthz_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    }
  },
  components: {
    schemas: {
      ExportMiniPosModel: {
        properties: {
          products: {
            additionalProperties: {
              type: "object"
            },
            type: "object",
            title: "Products"
          },
          timestamp: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Timestamp"
          },
          num_products: {
            type: "integer",
            title: "Num Products"
          }
        },
        type: "object",
        required: ["products", "num_products"],
        title: "ExportMiniPosModel"
      },
      HTTPValidationError: {
        properties: {
          detail: {
            items: {
              $ref: "#/components/schemas/ValidationError"
            },
            type: "array",
            title: "Detail"
          }
        },
        type: "object",
        title: "HTTPValidationError"
      },
      PaginationViewResponseIntIdsModel: {
        properties: {
          data: {
            anyOf: [{
              type: "object"
            }, {
              type: "null"
            }],
            title: "Data",
            "default": {}
          },
          skip: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Skip",
            nullable: true
          },
          limit: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Limit",
            nullable: true
          },
          max_results: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Max Results"
          },
          sort: {
            anyOf: [{
              type: "object"
            }, {
              type: "null"
            }],
            title: "Sort"
          },
          view: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "View"
          },
          ids: {
            anyOf: [{
              items: {
                type: "integer"
              },
              type: "array"
            }, {
              type: "null"
            }],
            title: "Ids",
            "default": []
          }
        },
        type: "object",
        title: "PaginationViewResponseIntIdsModel"
      },
      RenderProductGiftFinderResultStepModel: {
        properties: {
          skip: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Skip",
            nullable: true
          },
          limit: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Limit",
            nullable: true
          },
          max_results: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Max Results"
          },
          ids_merge_mode: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          sort: {
            anyOf: [{
              type: "object"
            }, {
              type: "null"
            }],
            title: "Sort",
            "default": {
              sku: 1
            }
          },
          options: {
            anyOf: [{
              type: "object"
            }, {
              type: "null"
            }],
            title: "Options",
            "default": {}
          },
          filter_class: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Filter Class"
          },
          reset: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            title: "Reset",
            "default": false
          },
          view: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "View"
          },
          filter: {
            anyOf: [{
              type: "object"
            }, {
              type: "null"
            }],
            title: "Filter",
            "default": {}
          },
          render_class: {
            type: "string",
            title: "Render Class"
          },
          org_id: {
            type: "string",
            title: "Org Id"
          },
          version: {
            type: "integer",
            title: "Version"
          },
          group_tags: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Group Tags"
          },
          price_start: {
            type: "integer",
            title: "Price Start"
          },
          price_end: {
            type: "integer",
            title: "Price End"
          },
          selected_group_tags: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Selected Group Tags"
          }
        },
        type: "object",
        required: ["render_class", "org_id", "version", "group_tags", "price_start", "price_end", "selected_group_tags"],
        title: "RenderProductGiftFinderResultStepModel"
      },
      RenderProductGiftFinderStepBaseModel: {
        properties: {
          render_class: {
            type: "string",
            title: "Render Class"
          },
          org_id: {
            type: "string",
            title: "Org Id"
          },
          version: {
            type: "integer",
            title: "Version"
          },
          group_tags: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Group Tags"
          },
          price_start: {
            type: "integer",
            title: "Price Start"
          },
          price_end: {
            type: "integer",
            title: "Price End"
          }
        },
        type: "object",
        required: ["render_class", "org_id", "version", "group_tags", "price_start", "price_end"],
        title: "RenderProductGiftFinderStepBaseModel"
      },
      RenderProductModel: {
        properties: {
          render_class: {
            type: "string",
            title: "Render Class"
          },
          org_id: {
            type: "string",
            title: "Org Id"
          },
          version: {
            type: "integer",
            title: "Version"
          },
          sku: {
            type: "integer",
            title: "Sku"
          },
          checksum: {
            type: "string",
            title: "Checksum"
          },
          data: {
            type: "object",
            title: "Data"
          }
        },
        type: "object",
        required: ["render_class", "org_id", "version", "sku", "checksum", "data"],
        title: "RenderProductModel"
      },
      RenderProductRequestModel: {
        properties: {
          org_id: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Org Id"
          },
          type: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Type",
            "default": "product"
          },
          channel: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Channel"
          },
          sku: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Sku"
          },
          checksum: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Checksum"
          },
          data: {
            anyOf: [{
              type: "object"
            }, {
              type: "null"
            }],
            title: "Data"
          },
          render_class: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Render Class"
          },
          render_all: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            title: "Render All",
            "default": false
          },
          render_async: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            title: "Render Async",
            "default": true
          },
          priority: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Priority"
          }
        },
        type: "object",
        title: "RenderProductRequestModel"
      },
      RenderRouteBaseModel: {
        properties: {
          uid: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Uid"
          },
          org_id: {
            type: "string",
            title: "Org Id"
          },
          render_class: {
            type: "string",
            title: "Render Class"
          }
        },
        type: "object",
        required: ["org_id", "render_class"],
        title: "RenderRouteBaseModel"
      },
      RenderRouteModel: {
        properties: {
          uid: {
            type: "string",
            title: "Uid"
          },
          org_id: {
            type: "string",
            title: "Org Id"
          },
          render_class: {
            type: "string",
            title: "Render Class"
          }
        },
        type: "object",
        required: ["uid", "org_id", "render_class"],
        title: "RenderRouteModel"
      },
      RenderedProductMetaDataRequestModel: {
        properties: {
          org_id: {
            type: "string",
            title: "Org Id"
          },
          render_class: {
            type: "string",
            title: "Render Class"
          },
          version: {
            type: "integer",
            title: "Version"
          },
          type: {
            type: "string",
            title: "Type"
          },
          filter: {
            anyOf: [{
              type: "object"
            }, {
              type: "null"
            }],
            title: "Filter"
          }
        },
        type: "object",
        required: ["org_id", "render_class", "version", "type"],
        title: "RenderedProductMetaDataRequestModel"
      },
      RenderedProductMetaDataResponseModel: {
        properties: {
          type: {
            type: "string",
            title: "Type"
          },
          data: {
            type: "object",
            title: "Data"
          },
          filter: {
            type: "object",
            title: "Filter"
          }
        },
        type: "object",
        required: ["type", "data", "filter"],
        title: "RenderedProductMetaDataResponseModel"
      },
      ValidationError: {
        properties: {
          loc: {
            items: {
              anyOf: [{
                type: "string"
              }, {
                type: "integer"
              }]
            },
            type: "array",
            title: "Location"
          },
          msg: {
            type: "string",
            title: "Message"
          },
          type: {
            type: "string",
            title: "Error Type"
          }
        },
        type: "object",
        required: ["loc", "msg", "type"],
        title: "ValidationError"
      }
    }
  }
};
var render_api = exports.render_api = (0, _lsfastapiClient.Api)(openapi);
//# sourceMappingURL=index.js.map